import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "nav-container" }
const _hoisted_2 = { class: "navbar navbar-light" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<a href=\"/\" class=\"navbar-brand logo-item\"><div class=\"logo-icon\"><img src=\"/images/logo-icon.png\" alt=\"#\"></div><div class=\"logo-text\"><img src=\"/images/logo-text.svg\" alt=\"#\"></div></a>", 1)
const _hoisted_5 = {
  class: "flex justify-content-end",
  id: "navbarNav"
}
const _hoisted_6 = { class: "navbar-block" }
const _hoisted_7 = {
  key: 0,
  class: "nav-item"
}
const _hoisted_8 = {
  key: 1,
  class: "nav-item dropdown"
}
const _hoisted_9 = {
  class: "dropdown-toggle",
  id: "profileDropDown",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_10 = { class: "dropdown-row" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "dropdown-header" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", null, "...", -1)
const _hoisted_14 = {
  class: "dropdown-menu dropdown-menu-end",
  "aria-labelledby": "dLabel"
}
const _hoisted_15 = /*#__PURE__*/_createTextVNode("My Gallery ")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Disconnect wallet ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("nav", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("ul", _hoisted_6, [
            (!$setup.isAuthenticated && !$setup.isLoading)
              ? (_openBlock(), _createElementBlock("li", _hoisted_7, [
                  _createElementVNode("button", {
                    id: "qsLoginBtn",
                    class: "btn-custom",
                    onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => ($setup.login && $setup.login(...args)), ["prevent"]))
                  }, " Login ")
                ]))
              : _createCommentVNode("", true),
            ($setup.isAuthenticated)
              ? (_openBlock(), _createElementBlock("li", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("img", {
                        src: $setup.user.picture,
                        alt: "User's profile picture",
                        class: "nav-user-profile rounded-circle"
                      }, null, 8, _hoisted_11),
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("span", null, [
                          _createElementVNode("span", null, _toDisplayString($setup.user.nickname?.slice(0, 5)), 1),
                          _hoisted_13,
                          _createElementVNode("span", null, _toDisplayString($setup.user.nickname?.slice(-4)), 1)
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_router_link, {
                      to: "/profile",
                      class: "dropdown-item dropdown-profile"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_font_awesome_icon, { icon: "user" }),
                        _hoisted_15
                      ]),
                      _: 1
                    }),
                    _createElementVNode("a", {
                      id: "qsLogoutBtn",
                      href: "#",
                      class: "dropdown-item",
                      onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => ($setup.logout && $setup.logout(...args)), ["prevent"]))
                    }, [
                      _createVNode(_component_font_awesome_icon, { icon: "power-off" }),
                      _hoisted_16
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ]))
}